import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiResponse } from '@custom/Utils/constants/interfaces';
import { _stripe_gateway } from '@custom/Utils/constants/apiUrls';

const deductCreditForStorage = createAsyncThunk('deductCreditForStorage', async (value:any,{rejectWithValue}) => {

  const token = sessionStorage.getItem('token') || localStorage.getItem('token');

  try {
    let response = await fetch(_stripe_gateway.deductCredits, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         Authorization: `Bearer ${token}`,
      },
      body : JSON.stringify(value)
    })
   return await response.json();

  } catch (error) {
    return error;
  }
});

export default deductCreditForStorage;
